import React from 'react';
import { Icon } from './Icon.js';
export const IconFilePlay = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M12 2V10H4", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M21 18.5L15 14.9999V21.9999L21 18.5Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M21 15.0088L19 13.8418V3H11.0059L5 9.00391V21H12V23H3V8.17578L3.29297 7.88281L9.88477 1.29297L10.1777 1H21V15.0088Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" })));
};
//# sourceMappingURL=IconFilePlay.js.map